import createRestfulModule from './restful-module'
import { actionClient } from '@/api'

export default createRestfulModule({

  state: {
    path: 'activity-products', // 资源路径
    defaultRels: ['productSpec', 'product'], // 默认需要的关联数据
  },

  actions: {
    async checkBatchProductDelete({}, { activityId, skus }) {
      return actionClient.get('activity-products-delete', {
        query: {
          activityId, skus
        }
      })
    },

    async batchProductDelete({}, { activityId, skus }) {
      return actionClient.post('activity-products-delete', {
        activityId, skus
      })
    },
  }

})
